/* eslint-disable dot-notation */
import moment from 'moment';
import { SORT_TYPES } from './constants';

// https://momentjs.com/docs/#/parsing/string-format/
export const ISO_8601_FORMATS = {
  DATE: 'YYYY-MM-DD',
  TIME: 'HH:mm',
};
//
export const US_FORMATS = {
  DATE: 'MM-DD-YYYY',
  TIME: 'hh:mm A',
};

const INTERNATIONAL_FORMATS = {
  DATE: 'DD/MMM/YYYY',
};

export const getDateFormat = me => {
  if (me) {
    if (
      me.data &&
      me.data.teams[0] &&
      me.data.teams[0].useInternationalDateFormat
    )
      return INTERNATIONAL_FORMATS.DATE;
    return me.data && me.data.teams[0] && me.data.teams[0].useIsoTimeFormat
      ? ISO_8601_FORMATS.DATE
      : US_FORMATS.DATE;
  }
  return US_FORMATS.DATE;
};
export const getTimeFormat = me => {
  if (me) {
    return me.data.teams[0].useIsoTimeFormat
      ? ISO_8601_FORMATS.TIME
      : US_FORMATS.TIME;
  }
  return US_FORMATS.TIME;
};
export const getDateTimeFormat = () => {
  return `${getDateFormat()} ${getTimeFormat()}`;
};

export const dateCompare = (a = null, b = null, direction = SORT_TYPES.ASC) => {
  if (a === null) {
    return direction === SORT_TYPES.ASC ? 1 : -1;
  }
  if (b === null) {
    return direction === SORT_TYPES.ASC ? -1 : 1;
  }

  const first = new Date(a);
  const second = new Date(b);

  if (direction === SORT_TYPES.DESC) {
    return second - first;
  }

  // default ASC
  return first - second;
};

export function renderDate(date, me) {
  return moment(date).format(getDateFormat(me));
}

export function renderTime(date, me) {
  return moment(date).format(getTimeFormat(me));
}

export const getYearMonthDateFormat = (rawTime, me) => {
  const conversion =
    rawTime.toString().includes('Z') || rawTime.toString().includes('+0000')
      ? rawTime.toString().slice(0, 10)
      : rawTime;
  const utcDate = moment.utc(conversion);
  const localDate = moment(utcDate).local();
  const month = (1 + localDate['_d'].getMonth()).toString().padStart(2, '0');
  const date = localDate['_d']
    .getDate()
    .toString()
    .padStart(2, '0');
  const year = localDate['_d'].getFullYear();
  const formattedDate = `${month}/${date}/${year}`;
  return renderDate(formattedDate, me);
};

export const getDateDiff = (d1, d2) => {
  const t2 = d2.getTime();
  const t1 = d1.getTime();
  return parseInt((t2 - t1) / (24 * 3600 * 1000), 10);
};

export const addDays = date => {
  // eslint-disable-next-line prettier/prettier
  return new Date(new Date(date).getTime() + (90 * 24 * 60 * 60 * 1000));
};



// WEBPACK FOOTER //
// ./src/common/dateUtils.js